var map = {
	"./1.svg": 83580,
	"./2.svg": 16337,
	"./3.svg": 52672,
	"./4.svg": 39246,
	"./5.svg": 16878,
	"./6.svg": 48672,
	"./7.svg": 59243,
	"./activity.svg": 10602,
	"./home.svg": 9539,
	"./vip.svg": 44166
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 15952;